<div>
    <div class="merchant-sign-contract-header-title">Your contract is ready!</div>
    <div class="merchant-sign-contract-header-subtitle">Please review the document and sign on the designated fields</div>
</div>
<div class="flex-row">
    <div class="merchant-sign-contract-column-50">
        <div class="merchant-sign-contract-img-block"></div>
    </div>

    <div class="merchant-sign-contract-column-50 merchant-sign-contract-right-column">
        <div class="merchant-sign-contract-info">Authorized signer: {{merchanUser.TradingName}}</div>
        <div class="merchant-sign-contract-info">Signatures remaining: {{12}}</div>

        <spinner *ngIf="isSpinnerVisible" style="margin-right: auto"></spinner>

        <div class="merchant-sign-contract-btn-block">
            <div>
                <!-- <button pButton
                        type="button"
                        label="Complete Signing"
                        style="color: #fff"
                        (click)="handleCompleteSigningClick()"></button> -->
                        <button mat-flat-button (click)="openChatSideBar()">I have a question</button>
            </div>
            <div style="margin-left: 20px">
                <!-- <button pButton
                        type="button"
                        label="I have a question"
                        style="color: #004060"
                        class="p-button-outlined"
                        (click)="openChatSideBar()"></button> -->
                        <!-- <button *ngIf="!isResumable" mat-flat-button color="primary" [disabled]="isVerifyingSignIn" (click)="handleEmailPopupContinueClick()">Complete Signing</button> -->
                        <button mat-flat-button color="primary" (click)="resume()">Resume</button>
            </div>
        </div>
    </div>
</div>

<div *ngIf="isZohoSignFormVisible" class="merchant-sign-contract-frame-wrap">
    <button mat-icon-button (click)="onCloseSigning()">
        <mat-icon>close</mat-icon>
    </button>
    <iframe [src]="merchantContractFormUrl"
            id="zohoSignForm"
            name="zohoSignForm"
            scrolling="yes"
            frameborder="0"
            (load)="handleZohoSignFormLoad()"
            class="merchant-sign-contract-frame"></iframe>
</div>

<p-toast position="top-right"></p-toast>

<ng-lottie *ngIf="showSplash" 
           [options]="options" 
           (animationCreated)="animationCreated($event)"
           (loopComplete)="loopComplete($event)" 
           [styles]="styles"></ng-lottie>
